import React, { Component } from "react";
import { Parse } from "parse";
//import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
//import styled from "styled-components";
import Header from "../Header/header";
import LandingHeader from "../Header/LandingHeader/landingheader";
import Footer from "../Footer/footer";

import { Contentstyled, Layoutstyled } from "../Constants/style";

import { Row, message, Spin } from "antd";

class StripeConfirmation extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      error: false
    };
  }

  async componentDidMount() {
    let pathname = this.props.location.search;
    console.log("pathname : ", pathname);
    let code = this.props.location.search.replace(
      "?scope=read_write&code=",
      ""
    );
    try {
      let response = await Parse.Cloud.run("confirmStripe", { code: code });
      //console.log("ma response : ", response);
      message.success("Compte Paramétré !");
      this.setState({ loading: false });
      return response.id;
    } catch (error) {
      console.log("error : ", error);
      this.error = error.message;
      this.setState({ loading: false, error: true });
    }
  }

  render() {
    if (this.state.loading === true) {
      return (
        <Layoutstyled>
          <Header />
          <LandingHeader />
          <Contentstyled>
            <Row
              style={{ marginTop: "200px" }}
              type="flex"
              justify="center"
              align="middle"
            >
              <Spin size="large" />
            </Row>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    } else if (this.state.error === true) {
      return (
        <Layoutstyled>
          <Header />
          <LandingHeader />
          <Contentstyled>
            <Row
              style={{ marginTop: "100px" }}
              type="flex"
              justify="center"
              align="middle"
            >
              Une erreur est survenue : {this.error}. Merci de contacter le
              support en leur précisant ce message d'erreur.
            </Row>
          </Contentstyled>
          <Footer />
        </Layoutstyled>
      );
    } else {
      return <Redirect to="/profile" />;
    }
  }
}

export default StripeConfirmation;
